import { Page } from "../../../components/page-base";
import gph from "../../../assets/images/logo-georanking.png";

import { isMobile } from "is-mobile";
import { UserInfoHeader } from "../../profile-dashboard/components/user-info-header";
import { BtnContainer, Container, LogoImg, TopContainer } from "./styles";
import { useState } from "react";
import HowItWorksModal from "../components/how-it-works-modal";
import theme from "../../../styles/theme";
import { Box } from "@mui/material";
import PlanInfoCard from "../components/plan-info-card";
import CheckoutForm from "../components/checkout-form";

export const Payment = () => {
  const [openHowItWorks, setOpenHowItWorks] = useState(false);
  const planMock = {
    name: "Plano Enterprise",
    priceMonthly: 799,
    badgeLabel: "Stripe PCI SAQ-A",
    infoLead: "Leva menos de 1 minuto.",
    infoText:
      "Hoje você paga a Adesão ao seu agente. Em seguida ativamos sua Assinatura no cartão.",
  };
  return (
    <Page.Root>
      <Container id="payment-container">
        <TopContainer>
          <LogoImg src={gph} />
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              marginRight: isMobile() ? "0" : "2vw",
            }}
          >
            <UserInfoHeader balance={0} userName="Ian Cordeiro" userRole="" />
          </div>
        </TopContainer>
        <Page.NavBar />
        <BtnContainer>
          <Page.Button
            bgColor={theme.colors.blue.primary}
            label="Como Funciona?"
            onClick={() => setOpenHowItWorks(true)}
            hoverBgcolor="#2C57A3"
          />
        </BtnContainer>
        <Box
          sx={{
            width: "85%",
            mt: 2,
            display: "flex",
            flexDirection: "column",
            gap: 3,
          }}
        >
          <PlanInfoCard
            name={planMock.name}
            priceMonthly={planMock.priceMonthly}
            badgeLabel={planMock.badgeLabel}
            infoLead={planMock.infoLead}
            infoText={planMock.infoText}
          />
          {/* NOVO FORM DE CHECKOUT */}
          <CheckoutForm planMonthlyCost={planMock.priceMonthly} />
        </Box>

        <HowItWorksModal
          open={openHowItWorks}
          onClose={() => setOpenHowItWorks(false)}
        />
      </Container>
    </Page.Root>
  );
};
